module.exports = __webpack_public_path__ + "static/fonts/Roboto-Light.a990f61.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Light.eot
// module id = 197
// module chunks = 1